module.exports = __webpack_public_path__ + "img/chart.7edcb29e.png";